import {
  StyleDocumentItems,
  StyleDocumentItem,
  styleDocumentUploadWrapper,
} from '../style'
import { Fragment } from 'react'
import Fields from '@components/fields'
import Column from '@components/column'
const Identifications = ({ identifications, disabled }: any) => {
  return (
    <StyleDocumentItems>
      {identifications?.map((_, index: number) => {
        return (
          <Fragment key={index}>
            <StyleDocumentItem>
              <Fields.Upload
                varient="drag"
                name={`identifications[${index}][image]`}
                placeholder="Upload Document Here"
                styleWrapper={styleDocumentUploadWrapper}
                size={180}
                icon={'circleGallery'}
                disabled={disabled}
              />
              <Column rowGap={20} styleColumn="margin-top:20px;">
                <Fields.Input
                  name={`identifications[${index}][name]`}
                  placeholder="Document Type"
                  label="Document Type"
                  disabled={true}
                />
                <Fields.Input
                  name={`identifications[${index}][number]`}
                  placeholder="Document Number"
                  label="Document Number"
                  disabled={disabled}
                />
              </Column>
            </StyleDocumentItem>
          </Fragment>
        )
      })}
    </StyleDocumentItems>
  )
}

export default Identifications
